import { FunctionComponent, useState } from 'react';
import { Typography, IconButton, Paper, Divider, Dialog, Table, TableRow, TableCell } from '../../tailwindcomponents';
import { EmployeeSearch } from '../../components';
import SkillApi from '../../api/skillsApi';
import { AssignedMechanicSkill, EmployeeAssigndToMechanicSkill, Skills } from '../../types/skills';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducer';
import { Delete } from '../../components/icons';
import { palette } from '../../theme/palette';
type SkillsProps = {
    allSkills: Skills[],
    loading: boolean,
    setLoading: Function,
}

const ManageSkills: FunctionComponent<SkillsProps> = ({ allSkills, setLoading }) => {
    const [selectedSkills, setSelectedSkills] = useState<number[]>([]);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState<number>(-1);
    const [assignedMechanicSkills, setAssignedMechanicSkills] = useState<AssignedMechanicSkill[]>([]);
    const [isAddDialogOpen, setIsAddDialogOpen] = useState<boolean>(false);
    const [isRemoveDialogOpen, setIsRemoveDialogOpen] = useState<boolean>(false);
    const [employeeAssigndToMechanicSkill, setEmployeeAssigndToMechanicSkill] = useState<EmployeeAssigndToMechanicSkill[]>([]);
    const [selectedEmployeeFromMechanicSkillList, setSelectedEmployeeFromMechanicSkillList] = useState<EmployeeAssigndToMechanicSkill>();
    const [isRemoveEmployeeFromSkillDialogOpen, SetRemoveEmployeeFromSkillDialogOpen] = useState<boolean>(false);

    const store = useSelector((state: RootState) => state);
    const selectedUser = store.employees.all_employees.find(s => s.user_id === selectedEmployeeId);

    const refreshEmployeeSkills = () => {
        setLoading(true);
        SkillApi.GetMechanicSkillsById(selectedEmployeeId).then(res => {
            setAssignedMechanicSkills(res.data);
            setLoading(false);
        });
    }

    const addSkillToMechanic = () => {
        setLoading(true);
        SkillApi.AssignMechanicSkills(selectedSkills, selectedEmployeeId).then(res => {
            refreshEmployeeSkills();
        });
    }
    const removeSkillFromMechanic = () => {
        setLoading(true);
        SkillApi.RemoveMechanicSkills(selectedSkills, selectedEmployeeId).then(res => {
            refreshEmployeeSkills();
        });
    }

    const removeEmployeeFromSkill = () => {
        setLoading(true);
        if (selectedEmployeeFromMechanicSkillList !== null && selectedEmployeeFromMechanicSkillList !== undefined) {
            SkillApi.RemoveMechanicSkills(selectedSkills, selectedEmployeeFromMechanicSkillList.EmployeeId).then(res => {
                refreshSkill();
            });
        }
    }

    const refreshSkill = () => {
        setLoading(true);
        SkillApi.GetEmployeesAssignedToMechanicSkillsById(selectedSkills[0]).then(res => {
            setEmployeeAssigndToMechanicSkill(res.data);
            setLoading(false);
        });
    }

    const onSelectMechanic = (employeeId: number) => {
        if (!employeeId) {
            setSelectedEmployeeId(-1);
            setAssignedMechanicSkills([]);
            return;
        }
        setSelectedEmployeeId(employeeId);
        setLoading(true);
        SkillApi.GetMechanicSkillsById(employeeId).then(res => {
            setAssignedMechanicSkills(res.data);
            setLoading(false);
        });
    }

    const onCloseAddDialog = (status: boolean) => {
        setIsAddDialogOpen(false);
        if (status === true) {
            addSkillToMechanic();
        }
        setSelectedSkills([]);
    }

    const onCloseRemoveDialog = (status: boolean) => {
        setIsRemoveDialogOpen(false);
        if (status === true) {
            removeSkillFromMechanic();
        }
        setSelectedSkills([]);
    }

    const onCloseRemoveEmployeeFromSkillDialog = (status: boolean) => {
        SetRemoveEmployeeFromSkillDialogOpen(false);
        if (status === true) {
            removeEmployeeFromSkill();
        }
    }

    const onSkillClicked = (skillId: number) => {
        if (selectedEmployeeId > 0) {
            setIsAddDialogOpen(true);
            setSelectedSkills([skillId]);
        } else {
            setLoading(true);
            setSelectedSkills([skillId]);
            SkillApi.GetEmployeesAssignedToMechanicSkillsById(skillId).then(res => {
                setEmployeeAssigndToMechanicSkill(res.data);
                setLoading(false);
            });
        }
    }

    const generateTableBody = (row: AssignedMechanicSkill, index: number) => {
        return (
            <TableRow>
                <TableCell>{index}</TableCell>
                <TableCell>{row.SkillName}</TableCell>
                <TableCell>{row.CreatedDateText}</TableCell>
                <TableCell>
                    <IconButton onClick={() => { setIsRemoveDialogOpen(true); setSelectedSkills([row.SkillId]) }} style={{ color: palette.error }} >
                        <Delete />
                    </IconButton>
                </TableCell>
            </TableRow>
        )
    }

    const generateTableBodySkillOverview = (row: EmployeeAssigndToMechanicSkill, index: number) => {
        return (
            <TableRow>
                <TableCell>{index}</TableCell>
                <TableCell>{row.Name}</TableCell>
                <TableCell>{row.AssignedAtDate}</TableCell>
                <TableCell>
                    <IconButton onClick={() => { SetRemoveEmployeeFromSkillDialogOpen(true); setSelectedEmployeeFromMechanicSkillList(row) }} style={{ color: palette.error }} >
                        <Delete />
                    </IconButton>
                </TableCell>
            </TableRow>
        )
    }

    return (
        <div>
            <div className="ml-[15%] mb-7">
                <div>
                    <EmployeeSearch
                        inputWidth={75}
                        place_holder={"Write employee name"}
                        onSelectedEmployee={(employeeId: number) => { onSelectMechanic(employeeId) }}
                        customCloseFunction={() => { }}
                    />
                </div>
            </div>
            <div className="flex flex-wrap">
                <div className="w-[31%] cursor-pointer">
                    <Typography variant={'h2'} align={'center'} text={"All skills"} margin={[0, 0, 0, 0]} />
                    {
                        allSkills !== undefined && allSkills.filter(type => type.Visible === true).map((row, index) => (
                            <Paper className="w-[90%] h-[35px] m-2 pt-1 cursor-pointer" key={index} elevation={10} variant="elevation" onClick={() => { onSkillClicked(row.Id) }}>
                                <div className="flex flex-wrap content-center items-center" >
                                    <div className="w-full">
                                        <Typography cursor={"pointer"} align={'center'} text={row.Skill} margin={[0, 0, 0, 0]} />
                                    </div>
                                </div>
                            </Paper>
                        ))
                    }
                </div>
                <Divider orientation="vertical" flexItem className="w-[6px] mr-[42px]" />
                <div className="w-1/2">
                    {(selectedUser !== null && selectedEmployeeId > 0) &&
                        <Typography text={`Skills assigned to ${selectedUser?.name}`} color={'primary'} variant={'h2'} align={'left'} margin={[0, 0, 2, 0]} />
                    }
                    {(assignedMechanicSkills.length > 0 && selectedEmployeeId > 0) &&
                        <Table
                            headers={["Mechanic Skill", "Assigned at", ""]}
                            rows={assignedMechanicSkills}
                            generateBody={(row: any, index: number) => generateTableBody(row, index)}
                            defaultRowsPerPage={100}
                        />
                    }
                    {((selectedEmployeeId <= 0 || selectedEmployeeId === null) && selectedSkills.length > 0) &&
                        <Typography text={`Emplyees with skill ${allSkills.find(s => s.Id === selectedSkills[0])?.Skill}`} color={'primary'} variant={'h2'} align={'left'} margin={[0, 0, 2, 0]} />
                    }
                    {(employeeAssigndToMechanicSkill.length > 0 && (selectedEmployeeId <= 0 || selectedEmployeeId === null) && selectedSkills.length > 0) &&
                        <Table
                            headers={["Employee", "Assigned at", ""]}
                            rows={employeeAssigndToMechanicSkill}
                            generateBody={(row: any, index: number) => generateTableBodySkillOverview(row, index)}
                            defaultRowsPerPage={100}
                        />
                    }
                </div>
            </div>
            <Dialog
                visible={isAddDialogOpen}
                max_width={"md"}
                title={`Add skill ${allSkills.find(s => s.Id === selectedSkills[0])?.Skill} to ${selectedUser?.name}`}
                context={
                    <div>
                    </div>
                }
                onClose={(status: any) => { onCloseAddDialog(status) }}
                strict={false}
                show_options={true}
            />
            <Dialog
                visible={isRemoveDialogOpen}
                max_width={"md"}
                title={`Remove skill ${allSkills.find(s => s.Id === selectedSkills[0])?.Skill} from ${selectedUser?.name}`}
                context={
                    <div>
                    </div>
                }
                onClose={(status: any) => { onCloseRemoveDialog(status) }}
                strict={false}
                show_options={true}
            />
            <Dialog
                visible={isRemoveEmployeeFromSkillDialogOpen}
                max_width={"md"}
                title={`Remove skill ${allSkills.find(s => s.Id === selectedSkills[0])?.Skill} from ${selectedEmployeeFromMechanicSkillList?.Name}`}
                context={
                    <div>
                    </div>
                }
                onClose={(status: any) => { onCloseRemoveEmployeeFromSkillDialog(status) }}
                strict={false}
                show_options={true}
            />
        </div>
    )
}

export default ManageSkills